import { SocialRegistrationState } from '@/model/SocialRegistrationState'

const initialState: SocialRegistrationState = {
  socialRegistration: false,
  firstname: '',
  lastname: '',
  email: '',
}

export const socialRegistration = {
  namespaced: true,
  state: initialState,
  actions: {
    socialRegister(
      { commit }: Record<any, any>,
      { firstname, lastname, email }: Record<any, string>
    ) {
      commit('socialRegistrationSet', { firstname, lastname, email })
    },
    finishSocialRegister({ commit }: Record<any, any>) {
      commit('socialRegistrationUnset')
    },
  },
  mutations: {
    socialRegistrationSet(
      state: SocialRegistrationState,
      { firstname, lastname, email }: Record<any, string>
    ) {
      state.socialRegistration = true
      state.firstname = firstname
      state.lastname = lastname
      state.email = email
    },
    socialRegistrationUnset(state: SocialRegistrationState) {
      state.socialRegistration = false
      state.firstname = ''
      state.lastname = ''
      state.email = ''
    },
  },
}
